import React from 'react';
 import { Form, Formik } from 'formik';
 import '../styles/Formik.css'
 import '../styles/SE.css'
 import '../styles/Breezer.css'
 import '../styles/Tuesday.css'
 import '../styles/Fuji.css'
 import {prodregSchema} from '../utils/schemas';
 import FormikInput from '../questions/FormikInput';
 import FormikDate from '../questions/FormikDate';
 import FormikCheckbox from '../questions/FormikCheckbox';
 import FormikState from '../questions/FormikState';
 import FormikInputNonReq from '../questions/FormikInputNonReq';
 import FormikPhone from '../questions/FormikPhone';
 import FormikRecaptcha from '../questions/FormikRecaptcha';
 import FormikSerialNo from '../questions/FormikSerialNo';
 import FormikFile from '../questions/FormikFile';
 import axios from 'axios';
 import FormikCountry from "../questions/FormikCountry";

const ProdregForm = ({className, brand, email}) => {

  const initialValues = {
      fname: "",
      lname: "",
      city: "",
      state: "",
      zip: "",
      country: "United States",
      email: "",
      brand: brand,
      model: "",
      size: "",
      store: "",
      serialNo: "",
      dateOfPurchase: "",
      price: "",
      newsletter: true,
      phone: "",
      sms: true,
      captcha:""
     }

     const onSubmit = async (values, actions) => {
      console.log(values);
      actions.setSubmitting(true);
      // upload receipt to database
      if (values.receipt) {
          const data = new FormData() 
          data.append('file', values.receipt)
          data.append('name', values.fileName)
          const urlUpload = "https://api.thebikeco.com/prodreg/backend/upload.php";
          const response = await axios.post(urlUpload, data, {})
          const result = response.data;
          console.log(result);
      }
  
      const url= "https://api.thebikeco.com/prodreg/backend/register-formik.php";
      await axios.post(url, values)
      .then(res => {
        console.log(res.data);
        alert("Your has been registered! You should receive a confirmation email.")
      })
      .catch(err => {
        console.log(err);
        alert("Registration failed, please try again later. If problem persists, contact "+email)
      });
      
      
    actions.resetForm({values:initialValues});
    window.grecaptcha.reset();
    window.scrollBy(-10000, -10000);
    actions.setSubmitting(false);
  }

     return(
      <div className={`formik ${className}`}>
        
      <h2>Register your Bike</h2>
      <Formik
        initialValues={initialValues}
        validationSchema={prodregSchema}
        onSubmit={onSubmit}>
          {props => (
            
            <Form>
              <FormikInput name="fname" placeholder="First Name"/>
              <FormikInput name="lname" placeholder="Last Name"/>
              <FormikInput name="city" placeholder="City"/>
              <FormikInput name="zip" placeholder="Postal Code"/>
              <FormikState name="state" placeholder="Select a State"/>
              <FormikCountry name="country" placeholder="Select a Country"/>
              <FormikInput name="email" placeholder="Email"/>
              <FormikCheckbox type="checkbox" name="newsletter" label="Sign up for our newsletter"/>
              <FormikPhone name="phone"/>
              <FormikCheckbox type="checkbox" name="sms" label="Sign up for SMS messages"/>
              <FormikInput name="model" placeholder="Model Name"/>
              <FormikInput name="size" placeholder="Bike Size"/>
              <FormikSerialNo name="serialNo" placeholder="Serial No."/>
              <FormikInput name="store" placeholder="Retailer purchased from"/>
              <FormikInputNonReq name="price" placeholder="Purchase price (mention currency type)"/>
              <FormikDate name="dateOfPurchase"/>
              <FormikFile name="receipt" lname={props.values.lname} serialNo={props.values.serialNo}/>
              <FormikRecaptcha name="captcha"/>
              <button className='btn-register' type='submit' disabled={props.isSubmitting}>Submit</button>
            </Form>
          )}
      </Formik>
      </div>
     )
};
export default ProdregForm;

